<template>
  <div ref="inputEl" class="drugstore-input-wrapper" :class="{ focus: isFocus }" :style="{ width }">
    <div class="label" :style="{ width: labelWidth }">
      <slot name="label">
        <span class="label-text" :class="[labelAlign]">
          {{ label }}
        </span>
      </slot>
    </div>
    <div class="controller">
      <slot>
        <template v-if="type === 'input'">
          <el-input
            :disabled="disabled"
            class="label-input"
            :value="value"
            :placeholder="placeholder"
            @input="val => $emit('input', val)"
            v-bind="inputAttr"
          ></el-input>
        </template>
        <template v-else>
          <el-autocomplete
            class="label-autocomplete"
            :value="value"
            @input="handleInput"
            @select="handleSelect"
            :trigger-on-focus="false"
            :fetch-suggestions="querySearch"
            :placeholder="placeholder"
            popper-class="label-autocomplete-popper"
            :disabled="disabled"
            v-bind="inputAttr"
          >
            <template #default="{ item }">
              <span class="autocomplete-item">{{ item[valueKey] }}</span>
            </template>
          </el-autocomplete>
        </template>
      </slot>
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'drugstore-input',
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    label: {
      type: String
    },
    labelWidth: {
      type: String,
      default: '80px'
    },
    labelAlign: {
      type: String,
      default: 'left' /*center left right justify*/
    },
    querySearch: {
      type: Function,
      default: (queryString, cb) => {
        // 默认查询药店
        if (queryString.length > 1) {
          Fetch.getStoreList({ storeName: queryString, isDelete: 0 }).then(({ data }) => {
            cb(data);
          });
        } else {
          cb([]);
        }
      }
    },
    value: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'name'
    },
    type: {
      type: String,
      default: 'input'
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputAttr: {
      type: Object
    },
    _parent: {
      type: Object
    }
  },
  data() {
    return {
      isFocus: false
    };
  },
  methods: {
    handleFocus() {
      this.isFocus = !this.isFocus;
    },
    handleInput(val) {
      this.handleStoreId();
      this.$emit('input', val);
    },
    handleSelect(item) {
      this.handleStoreId(item.id);
      this.$emit('input', item[this.valueKey]);
    },
    handleStoreId(id) {
      if (this.label.indexOf('门店') > -1 && this?._parent?.setFormStoreId) {
        this._parent.setFormStoreId(id);
      }
    }
  },
  mounted() {
    this.$refs.inputEl.addEventListener('focusin', this.handleFocus);
    this.$refs.inputEl.addEventListener('focusout', this.handleFocus);
  },
  beforeDestroy() {
    this.$refs.inputEl.removeEventListener('focusin', this.handleFocus);
    this.$refs.inputEl.removeEventListener('focusout', this.handleFocus);
  }
};
</script>

<style lang="scss" scoped>
.drugstore-input-wrapper {
  display: inline-flex;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  box-sizing: border-box;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    border: 1px solid #bdbdbd;
  }

  &.focus {
    border: 1px solid #1e8dff;
  }

  .label {
    position: relative;
    padding: 0 12px;
    display: flex;
    align-items: center;
    color: #707070;
    box-sizing: border-box;

    &::after {
      position: absolute;
      top: 50%;
      right: 0;
      width: 1px;
      height: 14px;
      transform: translateY(-50%);
      background-color: #f2f2f2;
      content: '';
    }

    .label-text {
      display: inline-block;
      width: 100%;
      font-size: 14px;
      color: #707070;

      &.center {
        text-align: center;
      }

      &.left {
        text-align: left;
      }

      &.justify {
        text-align-last: justify;
      }

      &.right {
        text-align: right;
      }
    }
  }

  .controller {
    flex: 1;

    .label-input,
    .label-autocomplete {
      width: 100%;
    }

    /deep/ input {
      border: none !important;
    }
  }
}
</style>

<style lang="scss">
.label-autocomplete-popper {
  .autocomplete-item {
    display: flex;
    padding: 5px;
    word-break: break-all;
    white-space: break-spaces;
    line-height: 1.5;
  }
}
</style>
